export const tableColumns = [
  "Claim ID",
  "PNR Number",
  "Mobile",
  "Fare Amount",
  "Journey Date",
  "Claim Date",
  "Claim Status",
  "Action",
  "",
];
